document.addEventListener('DOMContentLoaded', () => {

	// helper: zet watch/short/embed URLs om naar embed-URL met autoplay
	function toEmbedUrl(url) {
		const ytWatch = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/;
		const ytShort = /(?:https?:\/\/)?youtu\.be\/([^?&]+)/;
		const ytEmbed = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([^?&]+)/;
		let id = null;
		let match = null;

		if ((match = url.match(ytEmbed))) {
			id = match[1];
		}
		else if ((match = url.match(ytWatch))) {
			id = match[1];
		}
		else if ((match = url.match(ytShort))) {
			id = match[1];
		}

		if (id) {
			return `https://www.youtube.com/embed/${id}?autoplay=1`;
		}
		// geen match? fallback
		return url;
	}

	const swiper = new Swiper('.swiper', {
		loop: false,
		speed: 1200,
		effect: 'slide',
		// loopAdditionalSlides: 3,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			//   dynamicBullets: true,
			//   dynamicMainBullets: 3
			dynamicBullets: false
		},
		navigation: {
			nextEl: '.video-carousel-next',
			prevEl: '.video-carousel-prev'
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false
		},
		observer: true,
		observeParents: true
	});

	document.querySelectorAll('.play-video-btn').forEach(btn => {
		btn.addEventListener('click', () => {
			const slide = btn.closest('.video-carousel-slide');
			const videoUrl = slide.dataset.video;
			if (videoUrl) {
				const embedUrl = toEmbedUrl(videoUrl);
				document.querySelector('.video-container').innerHTML =
					`<iframe src="${embedUrl}"
               allow="autoplay; encrypted-media"
               allowfullscreen></iframe>`;
				document.querySelector('.video-overlay').classList.remove('hidden');
			}
		});
	});

	document.querySelector('.close-video').addEventListener('click', () => {
		document.querySelector('.video-overlay').classList.add('hidden');
		document.querySelector('.video-container').innerHTML = '';
	});
	document.querySelector('.video-overlay').addEventListener('click', e => {
		if (e.target === e.currentTarget) {
			document.querySelector('.video-overlay').classList.add('hidden');
			document.querySelector('.video-container').innerHTML = '';
		}
	});

});
